<template>
  <div>
    <div class="p-1 alert-danger d-flex justify-content-center" role="alert" v-if="parseInt(get_user.profile.deposit_pending) == 1 && parseInt(get_user.lead_type) == 0">
      <span class="mb-0 mr-2">You have a pending deposit, to process it kindly </span>
      <router-link :to="parseInt(profileInfo.tier) == 1 ? '/individual-step3' : '/help-centre'" class="f-14 underline">Upgrade Account</router-link>
    </div>
    <section class="top_searchbar d-flex align-items-center justify-content-between border-top-0">
      <div class="px-3 hideMob-title" :class="$route.path == '/complete-steps' ? 'col-md-6' : ''">
        <div class="section_title mb-0">
          <h5>{{ pageTxt1 }}</h5>
        </div>
      </div>
      <div class="px-3 customMobMenu onltWEB">
        <div class="d-flex align-items-center justify-content-end mobDir">
          <!-- <div class="mr-3 mobTrade hideMobile">
            <a :href="$env_var.webTrader + token" target="_blank" class="borderBtn">
              Advanced Trading</a>
          </div> -->
          <nav class="cap_profile navbar" :class="
              $route.path == '/complete-steps' ? 'd-flex align-items-center' : ''
            ">
            <div class="notification">
              <ul class="nav customNotify">
                <li class="nav-item dropdown">
                  <a class="nav-link p-0" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <feather type="bell"></feather>
                    <span class="number" v-if="notificationUnreadList.totalRecords > 0">{{
                      notificationUnreadList.totalRecords }}</span>
                  </a>
                  <div class="dropdown-menu">
                    <div class="head">
                      <div class="d-flex align-items-center justify-content-between">
                        <span>Notifications ({{
                          notificationUnreadList.totalRecords || 0
                          }})</span>
                          <span class="textLink" v-if="notificationUnreadList.totalRecords > 0" @click="markasRead()">Mark as read</span>
                        <router-link to="/notification" class="textLink">View all</router-link>
                      </div>
                    </div>
                    <ul class="dropdown-menu-sup scrollbar" v-if="notificationUnreadList.totalRecords > 0">
                      <li class="notification-box d-flex align-items-center"
                        v-for="list in notificationUnreadList.records.slice(0,15)">
                        <feather type="user" class="bg-secondary rounded-circle"></feather>
                        <div class="dueName">
                          <p class="notifyInt mb-0" v-html="list.msg"></p>
                          <span>{{ dateFunction(list.created) }}</span>
                        </div>
                      </li>
                    </ul>
                    <ul v-else>
                      <li class="notification-box noneNotify">
                        <div class="imgNorIcon">
                          <img src="../../../../static/website/images/4707150.svg" alt="Icon" />
                          <h5>No message notification</h5>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
            <ul class="nav-menu leftDrop-down border-left pl-3">
              <li class="nav-item dropdown">
                <a href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                  class="nav-link onlyweb-show">
                  <span v-if="
                      get_user.profile.firstname != '' &&
                      get_user.profile.firstname != null
                    ">{{ get_user.profile.firstname
                    }}{{ get_user.lastname ? get_user.lastname : "" }}</span>
                  <span v-else>{{ get_user.email }}</span>
                  <feather class="icon" type="chevron-down"></feather>
                </a>
                <a href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                  class="nav-link onlyMoble-show">
                  <span v-if="
                      get_user.profile.firstname != '' &&
                      get_user.profile.firstname != null
                    ">{{ get_user.profile.firstname.charAt(0)
                    }}{{
                    get_user.lastname ? get_user.lastname.charAt(0) : ""
                    }}</span>
                  <span v-else>{{ get_user.email.charAt(0) }}</span>
                  <feather class="icon" type="chevron-down"></feather>
                </a>
                <div class="dropdown-menu newMegaDropDown box-shadow">
                  <div class="userName">
                    <p class="fLetter">A</p>
                    <h5>{{ get_user.username }}</h5>
                    <p>{{ get_user.email }}</p>
                  </div>
                  <ul aria-labelledby="languages">
                    <li>
                      <router-link to="/settings" class="dropdown-item">Settings</router-link>
                    </li>
                    <li>
                      <router-link to="/help-centre" class="dropdown-item">Help & Support</router-link>
                    </li>
                    <!-- <li><a href="javascript:void(0)" class="dropdown-item">About US</a></li> -->
                    <li v-if="parseInt(get_user.tier) == 1">
                      <router-link :to="'/individual-step' + (parseInt(get_user.step) + 1)" class="dropdown-item" v-if="
                          parseInt(get_user.lead_type) == 0 &&
                          parseInt(get_user.step) < 3
                        ">
                        Upgrade to higher limits
                      </router-link>
                      <router-link :to="'/corporate-step' + (parseInt(get_user.step) + 1)" class="dropdown-item" v-if="
                          parseInt(get_user.lead_type) == 1 &&
                          parseInt(get_user.step) < 4
                        ">
                        Upgrade to higher limits
                      </router-link>
                    </li>
                    <!-- <li v-else-if="parseInt(get_user.tier)==2"> <a href="#" @click.prevent.stop="" class="dropdown-item disabled" title="Your Account is under verification">Upgrade to higher limits</a> </li>-->
                    <li v-else-if="parseInt(get_user.tier) == 3">
                      <router-link :to="{
                          name: 'help_centre',
                          params: {
                            page: 'profile',
                            ticketData: '16',
                            method_id: '1',
                          },
                        }" @click.prevent="" class="dropdown-item">
                        Upgrade to withdraw fiat
                      </router-link>
                    </li>
                    <!-- <li v-else-if="parseInt(get_user.tier)==4"> <a href="#" @click.prevent.stop="" class="dropdown-item disabled" title="Your bank account verification is under precess">Upgrade to higher limits</a> </li>-->
                    <!-- <li :class="$route.name=='payment-methods' ? 'active' : ''"><router-link class="dropdown-item" to="/payment-methods">Payment Methods</router-link></li> -->
                    <!-- <li :class="$route.name=='ip-whiteList' ? 'active' : ''"><router-link class="dropdown-item" to="/ip-whiteList">IP Whitelist </router-link></li> -->
                    <!-- <li :class="$route.name == 'api_access' ? 'active' : ''" v-if="
                        parseInt(get_user.lead_type) == 1 &&
                        parseInt(get_user.verified_status) == 1
                      ">
                      <router-link class="dropdown-item" to="/developer-option">Developer Option
                      </router-link>
                    </li> -->
                    <!-- <li><router-link to="/change-password" class="dropdown-item">Reset Password</router-link></li> -->
                    <li @click="logout()">
                      <a href="#" class="dropdown-item red">Sign Out</a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import * as types from "@/types";
  import { mapActions } from "vuex";
  import { commonAllmixins } from "@/plugins/commonAll";
  import moment from "moment";
  export default {
    name: "app-header",
    props: ["pageTxt1"],
    mixins: [commonAllmixins],
    data() {
      return {
        pageLoader: false,
        token: "",
      };
    },

    methods: {
      ...mapActions({
        _runstateLoad: types.RUN_STATE_LOAD,
        _runLogout: types.RUN_LOGOUT,
      }),
      dateFunction(getDate) {
        let last_seen_date = moment(getDate).fromNow();
        return last_seen_date;
      },
      logout() {
        if (this.pageLoader) {
          return;
        }
        let input_json = {
          globalParams: {},
          localParams: { parameter: this },
        };
        this._runLogout(input_json);
      },
      markasRead(){
          const _that = this
          this._runReadUnreadNotification({ 'globalParams' :{ }, 'localParams' :{ "parameter" : _that } })
      },
      afterUnread(){
          this._runGetNotificationList({'globalParams' : {read: "0"} ,'localParams' : {'parameter' : this}})
      }
      // refreshNotificaion() {
      //   this._runGetNotificationList({
      //     globalParams: {'read': 1},
      //     localParams: { parameter: this },
      //   });
      // },
    },
    created() {
      this.token = this.$store.getters[types.GET_TOKEN];
      //this._runGetNotificationList({ 'globalParams' :{}, 'localParams' :{ "parameter" : this } })
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/website/shared/header.vue